/*
 Copyright 2016-2021 the original author or authors from the JHipster project.

 This file is part of the JHipster project, see https://www.jhipster.tech/
 for more information.

 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

 http://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
 */
/* eslint no-bitwise: off */
import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class JhiBase64Service {
    private keyStr: string = 'ABCDEFGHIJKLMNOP' + 'QRSTUVWXYZabcdef' + 'ghijklmnopqrstuv' + 'wxyz0123456789+/' + '=';

    encode(input) {
        let output = '';
        let enc1: any = '';
        let enc2: any = '';
        let enc3: any = '';
        let enc4: any = '';
        let chr1: any = '';
        let chr2: any = '';
        let chr3: any = '';
        let i = 0;

        while (i < input.length) {
            chr1 = input.charCodeAt(i++);
            chr2 = input.charCodeAt(i++);
            chr3 = input.charCodeAt(i++);

          // tslint:disable-next-line:no-bitwise
            enc1 = chr1 >> 2;
          // tslint:disable-next-line:no-bitwise
            enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
          // tslint:disable-next-line:no-bitwise
            enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
          // tslint:disable-next-line:no-bitwise
            enc4 = chr3 & 63;

            if (isNaN(chr2)) {
                enc3 = enc4 = 64;
            } else if (isNaN(chr3)) {
                enc4 = 64;
            }

            output = output + this.keyStr.charAt(enc1) + this.keyStr.charAt(enc2) + this.keyStr.charAt(enc3) + this.keyStr.charAt(enc4);
            chr1 = chr2 = chr3 = '';
            enc1 = enc2 = enc3 = enc4 = '';
        }

        return output;
    }

    decode(input) {
        let output = '';
        let enc1: any = '';
        let enc2: any = '';
        let enc3: any = '';
        let enc4: any = '';
        let chr1: any = '';
        let chr2: any = '';
        let chr3: any = '';
        let i = 0;

        // remove all characters that are not A-Z, a-z, 0-9, +, /, or =
        input = input.replace(/[^A-Za-z0-9+/=]/g, '');

        while (i < input.length) {
            enc1 = this.keyStr.indexOf(input.charAt(i++));
            enc2 = this.keyStr.indexOf(input.charAt(i++));
            enc3 = this.keyStr.indexOf(input.charAt(i++));
            enc4 = this.keyStr.indexOf(input.charAt(i++));

          // tslint:disable-next-line:no-bitwise
            chr1 = (enc1 << 2) | (enc2 >> 4);
          // tslint:disable-next-line:no-bitwise
            chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
          // tslint:disable-next-line:no-bitwise
            chr3 = ((enc3 & 3) << 6) | enc4;

            output = output + String.fromCharCode(chr1);

            if (enc3 !== 64) {
                output = output + String.fromCharCode(chr2);
            }
            if (enc4 !== 64) {
                output = output + String.fromCharCode(chr3);
            }

            chr1 = chr2 = chr3 = '';
            enc1 = enc2 = enc3 = enc4 = '';
        }

        return output;
    }
}
